module.exports = __webpack_public_path__ + "img/f-thermometer-img8-2.a8351fd9.png";